var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedperinfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "302.269 181.695 446.69 136.61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.76,
    y1: 299.04,
    x2: 688.8,
    y2: 299.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#39b54a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662d91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 190.76,
    y1: 319.36,
    x2: 688.8,
    y2: 319.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 190.76,
    y1: 299.37,
    x2: 688.8,
    y2: 299.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 190.76,
    y1: 310.34,
    x2: 688.8,
    y2: 310.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 190.76,
    y1: 331.74,
    x2: 688.8,
    y2: 331.74,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,356.35H270.51V299.8a104.13,104.13,0,0,1,1-12.45l-14.79,58.52H248l-14.87-58.52a107.58,107.58,0,0,1,1,12.45v56.54H217.7V241.72h16.19l18,63.35a30.44,30.44,0,0,1,.44,5.2,43.22,43.22,0,0,1,.44-5.2l18-63.35H287V356.35Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.63,347.19q0,9.16-9.45,9.16H309.25q-9.45,0-9.45-9.16V291.53q0-9.15,9.45-9.16h28.93q9.45,0,9.45,9.16V318.7L343,323.32H315.84V344h15.75v-12.3h16v15.45Zm-16-34.79V294.68H315.84V312.4h15.75Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M584.32,347.19q0,9.16-9.45,9.16H545.94q-9.45,0-9.45-9.16V291.53q0-9.15,9.45-9.16h28.93q9.45,0,9.45,9.16V318.7l-4.61,4.61H552.53V344h15.75v-12.3h16v15.45Zm-16-34.79V294.68H552.53V312.4h15.75Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M596.35,357h16.87V262.88a6.42,6.42,0,0,1,6.58-6.26h20.54a6.43,6.43,0,0,1,6.58,6.26v19.5a6.43,6.43,0,0,1-6.58,6.25h-19.5v3.89c0.93,3.41,15.61,45.56,22.55,64.49h20.38l-20.32-53,0.27-.12h8.22c6.85,0,12.45-5.32,12.45-11.82V275.41c0-.84,0-1.69,0-2.54v-1.1l0,0.05c0-.21,0-0.43-0.05-0.65V253.54c0-6.5-5.61-11.82-12.46-11.82H630.52l0.06,0.06H608.78c-6.85,0-12.45,5.33-12.45,11.82v20.52c0,0.26,0,.51,0,0.78V357Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.29,322.06a48.34,48.34,0,0,0-6.32-24c-6.43-12.15-17.81-24.38-34-36.66H380.68q17.4,12,28.54,23.81c-9.32-.11-18.39-0.17-18.39-0.17v0.16a37,37,0,0,0,0,73.66V359s10.4,0.12,20.35.18l9,0c3.77,0,6.79,0,8.16-.08,0.68,0,1-.08.69-0.13A50.08,50.08,0,0,0,445.29,322.06Zm-17.77,9.34a31,31,0,0,1-8.82,13.94c1.48,0.29-24,0-24,0v-0.1a23.24,23.24,0,0,1,0-46.29v-0.11s25.5,0.16,24,.46a29.75,29.75,0,0,1,4,4.33,30.39,30.39,0,0,1,6.22,18.46A31.48,31.48,0,0,1,427.52,331.4Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493,285.27l0-.1H437.06A50,50,0,0,1,453.19,319c0,0.38,0,.75.06,1.13s0,0.51,0,.76c0.17,11.85-4.18,23.62-13.16,35.28-1,1.05-2,2.07-3.06,3l0.55,0.08a130.78,130.78,0,0,1-20.36,19.08H438.5a117.16,117.16,0,0,0,18.58-19.16H493L493,359A37,37,0,0,0,493,285.27Zm-1.7,60,0,0.06s-18.75.49-26.13,0.49a55.23,55.23,0,0,0,3.9-11.71l0.11-.58a49.23,49.23,0,0,0,.94-10.54c0-8.09-1.59-16.39-5-21.37q-0.58-1.32-1.23-2.64c5.17-.19,27.4,0,27.4,0l0,0.06c11,0.84,19.73,10.86,19.73,23.12S502.31,344.43,491.29,345.28Z",
    transform: "matrix(1, 0, 0, 1, 84.569459, -60.024995)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedperinfinity);
export default __webpack_public_path__ + "static/media/MEDPER INFINITY.0b41cbc41e9e6f02d22f37af82d75b34.svg";
export { ForwardRef as ReactComponent };